import React from 'react';
import './TypeFormatting.css';

const Dollars = ({ children }) => {
    // Ensure children is a number and convert to a float if needed
    const amount = parseFloat(children);
    
    // Create a formatter for USD currency
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    // Handle invalid or non-numeric values
    if (isNaN(amount)) {
        return <span>Invalid amount</span>;
    }

    return (
        <>
            {amount < 0 ?
                <span className='dollar-format negative-number'>{formatter.format(amount)}</span>
                : <span className='dollar-format'>{formatter.format(amount)}</span>
            }
        </>
    );
};

export default Dollars;